import * as Yup from "yup";

export const SupplierValidationSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  phone: Yup.string().nullable(),
  address: Yup.string().nullable(),
  notes: Yup.string().nullable(),
});
